module.exports = require('./lib/react-download');


//////////////////
// WEBPACK FOOTER
// ./~/@axetroy/react-download/index.js
// module id = 2949
// module chunks = 0